import { useContext, useEffect, useState } from 'react';

import DocumentContext from '../contexts/DocumentContext.context';
import { getSectionCount } from '../tiptap/nodes/section/SectionNode';
import { hasSectionElement } from '../largeDocument';
import { hasAiEditPreviewLandscapeSection } from '../tiptap/plugins/AiEditReviewPlugin';

// Listens to every transaction, not only `update` - an AI edit can show a landscape section as a decoration with no document change.
const useHasLandscapeSections = (): boolean => {
  const { editor } = useContext(DocumentContext);
  const [hasSection, setHasSection] = useState<boolean>(false);

  useEffect(() => {
    if (!editor) return;

    const update = () => {
      /**
       * Either source is enough. The model answers for the WHOLE document - a landscape section
       * outside the loaded part would otherwise be missed and the page sized for portrait - but it
       * only knows what has been committed, so a section just inserted into the live part would not
       * count until the next save and the paper would stay the wrong width while the user looks at it.
       */
      setHasSection(
        (hasSectionElement() ?? false) ||
          getSectionCount(editor.state) > 0 ||
          hasAiEditPreviewLandscapeSection(editor.state)
      );
    };

    editor.on('transaction', update);
    update(); // Initial check

    return () => {
      editor.off('transaction', update);
    };
  }, [editor]);

  return hasSection;
};

export default useHasLandscapeSections;
